import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateUserProfile } from "../../../redux/features/auth/authSliceNew";
import toastify from "../../../helper/toastify";

const FirstTimeProfileModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLogin, user, addressData } = useSelector((state) => state.auth);

  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [allowClose, setAllowClose] = useState(false);

  const mobile = useMemo(() => user?.mobile || "", [user]);

  const isProfileIncomplete = useMemo(() => {
    const hasName = Boolean(user?.name && String(user.name).trim().length > 0);
    const hasGender = Boolean(user?.gender && String(user.gender).trim().length > 0);
    return !(hasName && hasGender);
  }, [user]);

  useEffect(() => {
    if (user) {
      setName(user?.name || "");
      setGender(user?.gender || "");
    }
  }, [user]);

  // Modal is now manually triggered from LoginOtp component
  // No automatic trigger logic needed

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toastify.error("Please enter your full name");
      return;
    }
    if (!gender) {
      toastify.error("Please select your gender");
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        name: name.trim(),
        email: "",
        mobile: mobile,
        gender: gender,
        dob: "",
      };
      const result = await dispatch(updateUserProfile(payload));
      if (result?.success) {
        toastify.success("Your Profile updated successfully");
        localStorage.setItem("profile_completed_once", "1");
        localStorage.removeItem("just_logged_in");
        const modalEl = document.getElementById("firsttime-profile-modal");
        if (modalEl && window.bootstrap) {
          const instance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
          setAllowClose(true);
          instance.hide();
        }
        // Navigate to home page after successful profile update
        // Reload the page to ensure fresh state
        window.location.href = "/";
      }
    } catch (error) {
      // no-op; toast handled in slice if needed
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="modal fade login-modal"
      id="firsttime-profile-modal"
      tabIndex={-1}
      aria-labelledby="firstTimeProfileLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content simple-login-modal">
          <div className="modal-header simple-login-header">
            <div className="simple-login-title">
              <h3 className="modal-title" id="firstTimeProfileLabel">Complete Your Profile</h3>
              <p className="simple-login-subtitle">Just one last step to continue</p>
            </div>
          </div>
          <div className="modal-body simple-login-body">
            <form onSubmit={handleSubmit} className="simple-login-form" id="firsttime-profile-form">
              <div className="simple-login-input-section">
                <div className="simple-input-group">
                  <input
                    type="text"
                    className="form-control simple-input"
                    placeholder="Full Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="simple-input-group">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <label className="me-3 mb-0" style={{ fontWeight: 500 }}>Gender</label>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          id="genderMale"
                          value="male"
                          checked={gender === "male"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="genderMale">
                          Male
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          id="genderFemale"
                          value="female"
                          checked={gender === "female"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="genderFemale">
                          Female
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          id="genderOther"
                          value="other"
                          checked={gender === "other"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="genderOther">
                          Other
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="simple-input-group">
                  <input
                    type="text"
                    className="form-control simple-input"
                    placeholder="Mobile"
                    value={mobile ? `+91 ${mobile}` : ""}
                    readOnly
                    disabled
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer" style={{ borderTop: 'none' }}>
            <div className="w-100">
              <button
                className="thm-btn fill-btn simple-continue-btn w-100"
                type="submit"
                form="firsttime-profile-form"
                disabled={submitting}
              >
                {submitting ? (
                  <span className="simple-spinner">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span>Saving...</span>
                  </span>
                ) : (
                  <span>Update Profile</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeProfileModal;